import React, { useEffect } from "react";
import Card from "@mui/material/Card";
import SoftButton from "components/SoftButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import OrganizationData from "./organizationData";
import UserData from "./UserData";
import { useParams, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

function OrganizationMain() {
  const { orgTab } = useParams();
  const navigate = useNavigate();

  const activeTab = orgTab || "organization";

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Tabs */}
      <Card
        sx={{
          display: "flex",
          flexDirection: "row",
          mb: 1,
          p: 1,
          background: "#f5f7fa",
          borderRadius: "10px",
          width: "fit-content",
        }}
      >
        <SoftButton
          onClick={() => navigate("/super-admin/organization")}
          size="small"
          sx={{
            px: 3,
            borderRadius: "8px",
            fontWeight: 600,
            backgroundColor: activeTab === "organization" ? "#e3f2fd" : "#ffffff",
            color: activeTab === "organization" ? "#03a9f4" : "#9e9e9e",
            border: "2px solid",
            borderColor: activeTab === "organization" ? "#b3e5fc" : "#e0e0e0",
            borderBottom: "none",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            boxShadow: activeTab === "organization" ? "0 2px 6px rgba(3,169,244,0.15)" : "none",
            "&:hover": {
              backgroundColor: activeTab === "organization" ? "#e1f5fe" : "#fafafa",
            },
          }}
        >
          Organizations
        </SoftButton>

        <SoftButton
          onClick={() => navigate("/super-admin/admin")}
          size="small"
          sx={{
            px: 3,
            ml: 1,
            borderRadius: "8px",
            fontWeight: 600,
            backgroundColor: activeTab === "admin" ? "#e3f2fd" : "#ffffff",
            color: activeTab === "admin" ? "#03a9f4" : "#9e9e9e",
            border: "2px solid",
            borderColor: activeTab === "admin" ? "#b3e5fc" : "#e0e0e0",
            borderBottom: "none",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            boxShadow: activeTab === "admin" ? "0 2px 6px rgba(3,169,244,0.15)" : "none",
            "&:hover": {
              backgroundColor: activeTab === "admin" ? "#e1f5fe" : "#fafafa",
            },
          }}
        >
          Admins
        </SoftButton>
      </Card>

      {/* Tab Content */}
      {activeTab === "organization" && <OrganizationData />}
      {activeTab === "admin" && <UserData />}

      <Footer />
    </DashboardLayout>
  );
}

export default OrganizationMain;